export function getAttributeValue(attributes: any[], key: string): any {
    if (!attributes || !key) {
        return null;
    }

    const attribute = attributes.find((attr) => attr.key === key);
    if (!attribute) {
        return null;
    }

    return attribute.value;
}
